module.exports = __webpack_public_path__ + "static/media/ModernHam.5a263a6d.svg";